document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-bundle-personalize-submit]');
  if (!button) return;

  const root = button.closest('[data-bundle-destination]');
  if (!root) return;

  const destination = root.getAttribute('data-bundle-destination');
  const errorMessage = root.querySelector('.product-form__error-message');

  const items = [];
  root.querySelectorAll('[data-product-handle]').forEach((item) => {
    const handle = item.getAttribute('data-product-handle');
    const input = item.querySelector('input[name="id"]');
    const variantId = input ? input.value : '';

    if (handle && variantId) {
      items.push(`${handle}:${variantId}`);
    }
  });

  if (items.length === 0) {
    if (errorMessage) {
      errorMessage.textContent = 'No se pudo leer la selección de productos.';
      errorMessage.hidden = false;
    }
    return;
  }

  if (errorMessage) errorMessage.hidden = true;

  const url = new URL(destination, window.location.origin);
  const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
  url.searchParams.set('items', items.join(','));
  window.location.href = url.toString();
});
